export default __webpack_public_path__ + "images/loggedout/icons/parent_signup-ef322ef8139d9bd86a07778a4d0a70f7.png";